export default {
  possibleMatch: 3,
  offerMade: 4,
  shortlisted: 5,
  notAFit: 6,
  notHired: 7,
  hired: 8,
  offerDeclined: 9
};


// WEBPACK FOOTER //
// ./src/constants/application-substatuses.js